import React from "react";
import { WhatsappLogo, ShareNetwork } from "@phosphor-icons/react";
import { toast } from "sonner";
import { copyText } from "@/lib/clipboard";
import { useApp } from "@/context/AppContext";

export function ShareGuide() {
  const { t } = useApp();
  const url = `${window.location.origin}/nfc-guide.png`;
  const text = t("shareGuideText");
  const wa = `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`;

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "SafeBuddy", text, url }); } catch { /* cancelled */ }
    } else {
      await copyText(url);
      toast.success(t("linkCopied"));
    }
  };

  return (
    <div className="flex gap-2 mt-2">
      <a data-testid="guide-whatsapp" href={wa} target="_blank" rel="noreferrer"
        className="sb-btn flex-1 py-3 bg-white font-medium flex items-center justify-center gap-2 text-sm">
        <WhatsappLogo size={18} weight="fill" color="#25D366" />WhatsApp
      </a>
      <button data-testid="guide-share" type="button" onClick={share}
        className="sb-btn flex-1 py-3 bg-white font-medium flex items-center justify-center gap-2 text-sm">
        <ShareNetwork size={18} weight="bold" />{t("share")}
      </button>
    </div>
  );
}
